import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home')
  },
  {
    // 登入
    path: '/auth',
    name: 'Auth',
    component: () => import('../views/Auth')
  },
  {
    // 使用者資訊
    path: '/user',
    name: 'User',
    component: () => import('../views/User'),
    meta: { requiresAuth: true }
  },
  {
    // 修改使用者密碼
    path: '/edit-user',
    name: 'EditUser',
    component: () => import('../views/EditUser'),
    meta: { requiresAuth: true }
  },
  {
    // 商品列表
    path: '/products',
    name: 'ProductList',
    component: () => import('../views/Product/List')
  },
  {
    // 商品明細
    path: '/product/:productId',
    name: 'ProductDetail',
    component: () => import('../views/Product/Detail')
  },
  {
    // 獎勵歷程
    path: '/rewardLog',
    name: 'RewardLog',
    component: () => import('../views/RewardLog'),
    meta: { requiresAuth: true }
  },
  {
    // 地址管理
    path: '/address',
    name: 'Address',
    component: () => import('../views/Address'),
    meta: { requiresAuth: true }
  },
  {
    // 購物車
    path: '/cart',
    name: 'Cart',
    component: () => import('../views/Cart'),
    meta: { requiresAuth: true }
  },
  {
    // 訂單管理
    path: '/order',
    name: 'Order',
    component: () => import('../views/Order'),
    meta: { requiresAuth: true }
  },
  {
    // 股金歷程
    path: '/capitalLog',
    name: 'CapitalLog',
    component: () => import('../views/CapitalLog'),
    meta: { requiresAuth: true }
  },
  {
    // 付款流程
    path: '/pay',
    name: 'Pay',
    component: () => import('../views/Pay/Flow'),
    meta: { requiresAuth: true }
  },
  {
    // 成功頁面
    path: '/pay/success',
    name: 'PaySuccess',
    component: () => import('../views/Pay/Success'),
    meta: { requiresAuth: true }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About'),
    children: [
      {
        // 關於我們
        path: 'us',
        name: 'AboutUs',
        component: () => import('../views/About/Us')
      },
      {
        // 合作社介紹
        path: 'company-introduction',
        name: 'CompanyIntroduction',
        component: () => import('../views/About/CompanyIntroduction')
      },
      {
        // 合作社理念
        path: 'career-opportunity',
        name: 'CareerOpportunity',
        component: () => import('../views/About/CareerOpportunity')
      },
      {
        // 未來展望
        path: 'feature',
        name: 'Feature',
        component: () => import('../views/About/Feature')
      },
      {
        // 社會責任
        path: 'social-responsibility',
        name: 'SocialResponsibility',
        component: () => import('../views/About/SocialResponsibility')
      },
      {
        // 購物須知
        path: 'shop-note',
        name: 'ShopNote',
        component: () => import('../views/About/ShopNote.vue')
      }
    ]
  },
  {
    // 性騷擾頁面
    path: '/sexual-harassment',
    name: 'SexualHarassment',
    component: () => import('../views/SexualHarassment')
  },
  {
    // 聯絡我們
    path: '/contact-us',
    name: 'ContactUs',
    component: () => import('../views/ContactUs')
  },
  {
    // 最新消息
    path: '/news',
    name: 'News',
    redirect: { name: 'NewsList' },
    component: () => import('../views/News'),
    children: [
      {
        // 聯絡我們
        path: 'list',
        name: 'NewsList',
        component: () => import('../views/News/List')
      },
      {
        // 聯絡我們
        path: 'detail/:id',
        name: 'NewsDetail',
        component: () => import('../views/News/Detail')
      }
    ]
  }
  // TODO add error path component
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

router.beforeEach((to, from, next) => {
  if (to.name === null) {
    next('/')
  }

  const isLogin = store.getters.isLogin
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)
  if (requiresAuth) {
    if (store.getters.isLogin) {
      next()
    } else {
      next('/')
    }
  } else {
    if (to.name === 'Auth' && isLogin) {
      next('/')
    } else {
      next()
    }
  }
})

export default router
